/* THIS PAGE SHOULD BE EMPTY FOR ANY PRODUCTION BUILDS */
import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'

export default function EditTimesheetModal(props) {
    useEffect(() => {
        
    }, []);

    return(
        <Dialog disableEnforceFocus
            open={props.active}
            onClose={()=> {
                if(!!props.onHide){
                    console.log("GOT TO ONHIDE")
                    props.onHide()
                }
            }}
        >
            <DialogTitle>EDIT TIMESHEET RECORD</DialogTitle>
            <DialogContent>

            </DialogContent>
            <DialogActions>
            
            </DialogActions>
        </Dialog>
    );
}